<template>
  <drop @dragover="handleDragover(...arguments)" @drop="handleDrop">                      
    <v-tabs style="height:100%;display:flex;flex-direction:column;" v-model="selectedTab" align-with-title >              
        <simulation-detail-nav-tab class="simulationdetailtab" :uiid="simulation_uiid"  v-for="tab in tabItems" :key="`${tab.cmp}-${tab.id}-${isleft}`" :tab="tab" :isleft="isleft" />
       <v-tab style="flex:0 0 auto" href="SimulationMenu-0" class="simulationdetailmore" @click.stop.prevent="$store.myActions.UI_NAVTO_DETAIL({uiid:simulation_uiid,cmp:'SimulationMenu',isleft, id:0})" :title="$t('Pilot.MissionInfos.AddDetailTabTooltip')">
          <v-icon>mdi-plus</v-icon>
        </v-tab>             
      <v-tabs-items style="flex:1 1 auto;display:flex;" v-model="selectedTab">
          <v-tab-item  :reverse-transition="false" :transition="false" :value="`${tab.cmp}-${tab.id}`" v-for="tab in tabItems" :key="`${tab.cmp}-${tab.id}-${isleft}`">
            <component :is="tab.cmp" :isleft="isleft" :uiid="`${tab.cmp}-${tab.id}`" :tryClose="tab.tryClose" :isVisible="`${tab.cmp}-${tab.id}` == selectedTab"   />
          </v-tab-item>
          <v-tab-item :reverse-transition="false" :transition="false" value="SimulationMenu-0"  >            
            <simulation-menu :isleft="isleft" />        
        </v-tab-item>
      </v-tabs-items>                 
    </v-tabs>  
  </drop>   
</template>
<script lang="ts">

import { SimulationUiState, buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import SimulationMenu from '@/components/smart/SimulationMenu.vue'   
import SimulationDetailNavTab from '@/components/smart/SimulationDetailNavTab.vue'   
import SimulationDetailMap from '@/components/smart/SimulationDetailMap.vue'   
import SimulationDetailParameter from '@/components/smart/SimulationDetailParameter.vue'   
import CoverageDetailParameter from '@/components/smart/Coverage/CoverageDetailParameter.vue'   
import FormationDetailParameter from '@/components/smart/Formation/FormationDetailParameter.vue'   
import SimulationDetailMissionPlan from '@/components/smart/SimulationDetailMissionPlan.vue'   
import CoverageDetailMissionPlan from '@/components/smart/Coverage/CoverageDetailMissionPlan.vue'   
import SimulationDetailScienceGraphics from '@/components/smart/SimulationDetailScienceGraphics.vue'   
import SimulationDetailScienceGraphicsList from '@/components/smart/SimulationDetailScienceGraphicsList.vue'   
import SimulationDetailFileTransfert from '@/components/smart/SimulationDetailFileTransfert.vue'   
import SimulationDetailCompareSimulations from '@/components/smart/SimulationDetailCompareSimulations.vue'   
import SimulationDetailSinglePlotsList from '@/components/smart/SimulationDetailSinglePlotsList.vue'   
import CoverageDetailSinglePlotsList from '@/components/smart/Coverage/CoverageDetailSinglePlotsList.vue'
import SimulationDetailSinglePlots from '@/components/smart/SimulationDetailSinglePlots.vue'
import CoverageDetailSinglePlots from '@/components/smart/Coverage/CoverageDetailSinglePlots.vue'
import SimulationDetailMapLayer from '@/components/smart/SimulationDetailMapLayer.vue'   
import CoverageDetailFileTransfert from '@/components/smart/Coverage/CoverageDetailFileTransfert.vue'
import CoverageDetailScienceGraphicsList from '@/components/smart/Coverage/CoverageDetailScienceGraphicsList.vue'
import CoverageDetailScienceGraphics from '@/components/smart/Coverage/CoverageDetailScienceGraphics.vue'
 


@Component({
  name: 'SimulationDetail', 
  props: {            
    isleft:Boolean   
  },  
  components:{SimulationMenu,SimulationDetailNavTab,SimulationDetailMap,SimulationDetailMapLayer,SimulationDetailParameter,CoverageDetailParameter,FormationDetailParameter,SimulationDetailMissionPlan,CoverageDetailMissionPlan,SimulationDetailScienceGraphicsList,SimulationDetailScienceGraphics,SimulationDetailFileTransfert,SimulationDetailCompareSimulations,SimulationDetailSinglePlotsList,SimulationDetailSinglePlots,CoverageDetailSinglePlotsList,CoverageDetailSinglePlots,CoverageDetailFileTransfert,CoverageDetailScienceGraphicsList,CoverageDetailScienceGraphics}
})
export default class SimulationDetail extends Vue {      
    
  isleft!:boolean
  selectedTab:string|null = null

  get missionGlobal() {        
    return this.$store.myGetters.modifiedAdmMissionGlobal
  }

  get uistatebyuiid(){
    return this.$store.myGetters.uistatebyuiid
  }

  get simulation_uiid() {
   return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,"detail")
  }

  get simulationState() { 
   //retourne un MapUiState    
   return this.uistatebyuiid(this.simulation_uiid) as SimulationUiState         
 }

  get tabs(){
    return this.isleft?this.simulationState.tabsleft:this.simulationState.tabsright
  }

  get tabItems(){
    return this.tabs.tabs
  }

  get selectedUiid(){
    return this.tabs.selected
  }

  @Watch('selectedUiid')
  onSelectedUiidChange(newValue:string) {
    this.$nextTick(() => {               
      this.selectedTab = newValue                   
      this.$store.myActions.UI_REFRESH_COMPONENT(newValue)
    })
  }

  handleDragover(data:any, event:DragEvent) {
    if (data && ( !data.cmp || this.isleft == data.isleft)) {
      event.dataTransfer!.dropEffect = 'none';
    }
  }

  handleDrop(data:{ cmp:string, isleft:boolean, id:number }) {
    if (data)  this.$store.myActions.UI_MOVE_TAB({uiid:this.simulation_uiid,...data})
  }   
}
</script> 

<style scoped>
  .v-tabs{
    border-bottom:1px solid #efefef;
  }
  .simulationdetailtab, .simulationdetailmore{
    border-right:1px solid #efefef;
  }
  .simulationdetailtab  .v-tabs__item{
    padding-right: 0;
  }
  .v-tabs__content{
    display:flex;
  }
  
</style>
